import { BrandIconSVG } from 'atto-svgs';

import { styled } from '../../stitches.config';

export const BrandIconIcons = {
  'app-store': BrandIconSVG.AppStore,
  'google-play': BrandIconSVG.GooglePlay,
  'mac-app-store': BrandIconSVG.MacAppStore,
  wireguard: BrandIconSVG.Wireguard,
};

export type BrandIconName = keyof typeof BrandIconIcons;
export const BrandIconNames = Object.keys(BrandIconIcons) as BrandIconName[];

export interface BrandIconProps {
  icon: BrandIconName;
}

const BrandIconLiteral = styled('svg', {
  display: 'flex',
  width: 'auto',
});
BrandIconLiteral.displayName = 'BrandIconLiteral';

export function BrandIcon({ icon, ...remaining }: BrandIconProps) {
  const NamedIcon = BrandIconIcons[icon];

  if (!NamedIcon) {
    return null;
  }

  return <BrandIconLiteral as={NamedIcon} {...remaining} />;
}
